import axios from 'axios'
const loginHttp = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    baseURL: process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/api' : '/api',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=utf-8'
    }
})
var CAEnums={tgca:'tgca',ahca:'AH'};
var CAhb = {tgca:'',hnca:'HN'}
/**
 * 证书信息
 * */
var CertInfo=function () {
    //当前交易平台
    this.traddingOrgId='';
    //证书名称（友好名称）
    this.certName;
    //证书序列号
    this.certserial;
    //证书有效开始时间
    this.validstarttime;
    //证书有效截至时间
    this.validendtime;
    //证书拥有者名称
    this.subject_cn;
    //base64编码签名证书
    this.base64cert;
    //证书签名数据
    this.certsigndata;
    this.random;
    //判断是否有插入CA
    this.userCA;
}
/*
"caCode": "certserial",
"loginType": 1,
"originData": "random",
"provider": "AH",
"signCert": "base64cert",
"signData": "certsigndata",
*/

export   {
    CertInfo,CAEnums,CAhb
}


export function loacCaServer(provider,callback) {
    let url = "/oauth/getCaServer?provider="+provider
    loginHttp({
        url: url,
        method: 'post'
    }).then(({data}) =>{
        if (callback !== undefined) {
            callback(data)
        }else{
            console.log(data)
        }
    })
}

export function chooseTradding(code,callback) {
    let url = "/oauth/chooseTradding?code="+code
    loginHttp({
        url: url,
        method: 'post'
    }).then(({data}) =>{
        if (callback !== undefined) {
            callback(data)
        }else{
            console.log(data)
        }
    })
}
